<div class="files-input">
  <div class="files-list">
    @if (addedFiles.length) {
      @for (file of addedFiles; track file) {
        <div class="file-item">
          <button class="remove-file-button contact-form-remove-file" [attr.aria-label]="'Usuń plik ' + file.name" (click)="removeFile(file)" type="button"><i class="fa-sharp fa-regular fa-xmark"></i></button>
          <span class="file-name">{{ file.name }}</span>
        </div>
      }
    } @else {
      <span class="dimmed">Nie dodano żadnych plików</span>
    }
  </div>
  <div>
    <input [id]="inputId" (change)="addFiles($event)" name="files" type="file" #fileInput hidden multiple [accept]="ALLOWED_FILE_EXTENSIONS.join(',')" />
    <button class="mp-btn tw-discreet tw-border tw-extra-small contact-form-add-files" [disabled]="addedFiles.length === MAX_FILES_COUNT" (click)="selectFiles()" type="button">Wybierz pliki</button>
  </div>
</div>
